"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var AppIntegrationResourceStatus = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var placeholderImageUrl = "/images/no-image-placeholder.svg";
    var appIntegrationResource = props.appIntegration.definition.resources[props.identifier];
    var refreshOnDemand = ((_c = (_b = (_a = props.appIntegration.definition) === null || _a === void 0 ? void 0 : _a.setup) === null || _b === void 0 ? void 0 : _b.variables) === null || _c === void 0 ? void 0 : _c.refresh) ? true : false;
    var refreshTime = ((_d = appIntegrationResource === null || appIntegrationResource === void 0 ? void 0 : appIntegrationResource.variables) === null || _d === void 0 ? void 0 : _d.refresh)
        ? appIntegrationResource.variables.refresh
        : (_g = (_f = (_e = props.appIntegration.definition) === null || _e === void 0 ? void 0 : _e.setup) === null || _f === void 0 ? void 0 : _f.variables) === null || _g === void 0 ? void 0 : _g.refresh;
    var IntegrationJobStatus = function (args) {
        if (!args.ended_at) {
            return (react_1.default.createElement("span", { style: { marginRight: "4px" } },
                react_1.default.createElement(q_play_components_1.Spinner, null)));
        }
        switch (args.status) {
            case 0:
                return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-check", style: { color: "var(--success-color)", marginRight: "5px" } }));
            default:
                if (args.status > 0) {
                    return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-xmark", style: { color: "var(--warning-color)", marginLeft: "3px", marginRight: "7px" } }));
                }
                else {
                    return (react_1.default.createElement("span", { style: { marginRight: "4px" } },
                        react_1.default.createElement(q_play_components_1.Spinner, null)));
                }
        }
    };
    var IntegrationJobRunningState = function (args) {
        switch (args.state.status) {
            case 0:
            case 1:
                return (react_1.default.createElement("span", null, " - preparing"));
            case 2:
                return (react_1.default.createElement("span", null, " - init script"));
            case 3:
                return (react_1.default.createElement("span", null, " - resource script"));
            case 4:
                return (react_1.default.createElement("span", null, " - running"));
            case 5:
                return (react_1.default.createElement("span", null, " - capturing"));
            case 6:
                return (react_1.default.createElement("span", null, " - done"));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null));
    };
    var getIntegrationJobStatusMessage = function (status) {
        var _a;
        var statusTxt;
        var color;
        if (status === undefined || ((_a = props.latestIntegrationJob) === null || _a === void 0 ? void 0 : _a.ended_at) === undefined) {
            statusTxt = t("Pending");
            color = "var(--info-color)";
        }
        else {
            switch (status) {
                case 0:
                    statusTxt = t("Success");
                    color = "var(--primary-color)";
                    break;
                case 254:
                    statusTxt = t("Unable to communicate with server");
                    color = "var(--error-color)";
                    break;
                default:
                    statusTxt = t("Script failed");
                    color = "var(--error-color)";
                    break;
            }
        }
        return { statusTxt: statusTxt, color: color };
    };
    var FormattedDateTime = function (attrs) {
        if (attrs.dateTime) {
            var dt = attrs.dateTime instanceof Date ? attrs.dateTime : new Date(attrs.dateTime);
            return react_1.default.createElement("span", null, dt.getDate()
                + "/" + (dt.getMonth() + 1)
                + "-" + dt.getFullYear()
                + " " + ("0" + dt.getHours()).slice(-2)
                + ":" + ("0" + dt.getMinutes()).slice(-2)
                + ":" + ("0" + dt.getSeconds()).slice(-2));
        }
        return (react_1.default.createElement("span", null, "N/A"));
    };
    var _o = getIntegrationJobStatusMessage((_h = props.latestIntegrationJob) === null || _h === void 0 ? void 0 : _h.exit_code), statusTxt = _o.statusTxt, color = _o.color;
    return (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["resource-status-tab-content"], "data-cy": "resourceStatusTabContent", style: { display: "flex" } },
        react_1.default.createElement("div", { style: { marginTop: "1rem", marginRight: "1rem", flex: 1 } },
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                t("Resource status"),
                ":"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    t("Refresh"),
                    ":\u00A0"),
                react_1.default.createElement("span", null, refreshOnDemand ? t("On-demand") : t("Schedule"))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    t("Refresh time"),
                    ":\u00A0"),
                react_1.default.createElement("span", null, refreshTime !== null && refreshTime !== void 0 ? refreshTime : "N/A")),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    t("Last job started"),
                    ":\u00A0"),
                react_1.default.createElement(FormattedDateTime, { dateTime: (_j = props.latestIntegrationJob) === null || _j === void 0 ? void 0 : _j.created_at })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    t("Last job ended"),
                    ":\u00A0"),
                react_1.default.createElement(FormattedDateTime, { dateTime: (_k = props.latestIntegrationJob) === null || _k === void 0 ? void 0 : _k.ended_at })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    t("Last job status"),
                    ":\u00A0"),
                react_1.default.createElement(material_1.Typography, { sx: {
                        fontSize: "0.95rem",
                        fontFamily: "Geomanist",
                        color: color,
                        display: "inline",
                    } }, statusTxt !== null && statusTxt !== void 0 ? statusTxt : "N/A"))),
        react_1.default.createElement("div", { style: { marginTop: "1rem", marginRight: "1rem", flex: 1 } },
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                t("Latest run"),
                ":"),
            react_1.default.createElement("div", null, (_l = props.integrationJobList) === null || _l === void 0 ? void 0 : _l.map(function (result) {
                var _a;
                return (react_1.default.createElement("div", { key: result.id, title: getIntegrationJobStatusMessage(result.exit_code).statusTxt },
                    react_1.default.createElement(IntegrationJobStatus, { status: result.exit_code, ended_at: result.ended_at }),
                    result.id === ((_a = props.latestIntegrationJob) === null || _a === void 0 ? void 0 : _a.id) ? (react_1.default.createElement("strong", null,
                        react_1.default.createElement(FormattedDateTime, { dateTime: result.created_at }))) : (react_1.default.createElement("a", null,
                        react_1.default.createElement(FormattedDateTime, { dateTime: result.created_at }))),
                    props.jobStates["#" + result.id]
                        ? react_1.default.createElement(IntegrationJobRunningState, { state: props.jobStates["#" + result.id] })
                        : react_1.default.createElement(react_1.default.Fragment, null)));
            }))),
        react_1.default.createElement("div", { style: { marginTop: "1rem", marginLeft: "1rem", flex: 1 } },
            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
                react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, props.appIntegrationTemplate.type === "webapi"
                    ? ""
                    : t("Latest image")),
                react_1.default.createElement("a", { onClick: props.reloadResourceImage, style: { color: "var(--primary-color)", cursor: "pointer" } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faRefresh, color: "var(--primary-color)", style: { fontSize: "15px" } }))),
            react_1.default.createElement("div", { style: { textAlign: props.appIntegrationTemplate.type === "webapi" ? "left" : "center", position: "relative" } },
                props.appIntegrationTemplate.type === "webapi"
                    ? react_1.default.createElement("div", { style: { width: "330px", height: "215px", overflow: "scroll" } })
                    : react_1.default.createElement("a", { href: props.resourceImageUrl || placeholderImageUrl, target: "_blank", rel: "noreferrer" },
                        react_1.default.createElement("img", { src: props.resourceImageUrl || placeholderImageUrl, style: {
                                backgroundColor: "#eeeeee",
                                width: "100%",
                                maxWidth: "330px",
                                maxHeight: "215px",
                            }, onError: function (event) {
                                event.currentTarget.src = placeholderImageUrl;
                            } })),
                !((_m = props.latestIntegrationJob) === null || _m === void 0 ? void 0 : _m.ended_at) && (react_1.default.createElement("div", { style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255,255,255,.5)",
                        paddingTop: "20%"
                    } },
                    react_1.default.createElement(q_play_components_1.Spinner, null)))))));
};
exports.default = AppIntegrationResourceStatus;
